import "./lot.css";
import React, { createRef, useEffect, useRef, useState, useMemo } from "react";
import add from "../../images/icons/add.png";
import close from "../../images/icons/close.png";
import CustomButton from "../../components/CustomButton/custombutton";
import edit from "../../images/icons/edit.png";
import view from "../../images/icons/view.png";
import CustomSearchBar from "../../components/CustomSearchBar/CustomSearchBar";
import apiUtil from "../../api/apiUtil";
import { Box } from "@material-ui/core";
import Table from "../../components/Table/Table";
import api from "../../api/api";
import getToken, { redirectToLogin } from "../getToken";
import authStore from "../../store/authStore";
import CustomInput from "../../components/CustomInput/CustomInput";
import CustomSelect from "../../components/CustomSelect/CustomSelect";
import { FieldArray, Form, Formik } from "formik";
import * as Yup from "yup";
import { format, parseISO } from 'date-fns';
import { message } from "antd";

const Lot = () => {
    const refLotTable = useRef(null);
    const [selectedOption, setSelectedOption] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [isView, setIsView] = useState(false);
    const [keyword, setKeyword] = useState("");
    const lotId = useRef(0);
    const refSelectExpo = useRef();
    const refSelectMarker = useRef();
    const [expoNameList, setExpoNameList] = useState([]);
    const [markerNameList, setMarkerNameList] = useState([]);
    const [showAddLot, setShowAddLot] = useState(false);
    const [productListByMember, setProductListByMember] = useState([]);

    const mapLot = (data = {}) => ({
        expoId: data.expoId ?? "",
        expoName: data.expoName ?? "",
        memberId: data.memberId ?? "",
        lotName: data.lotName ?? "",
        serviceName: data.serviceName ?? "",
        rate: data.rate ?? "",
        weight: data.weight ?? "",
        price: data.price ?? "",
        saleAmount: data.saleAmount ?? "",
        markerName: data.markerName ?? "",
        percentage: data.percentage ?? "",
        serviceFee: data.serviceFee ?? "",
        totalPrice: data.totalPrice ?? "",
        description: data.description ?? "",
        carryFeeList: (data.carryFeeList ?? []).map(x => ({
            ...x,
            productId: x.productId ?? "",
            date: format(parseISO(x.date), 'yyyy-MM-dd'),
            carryName: x.carryName ?? "",
            count: x.count ?? ""
        })),
        protectionPriceList: data.protectionPriceList ?? [],
        refundPriceList: data.refundPriceList ?? [],
        colorEnhancedFeeList: data.colorEnhancedFeeList ?? [],
        depositList: data.depositList ?? []
    });
    const [detailLot, setDetailLot] = useState(() => mapLot());


    const buildLotPayload = (values, isUpdate = false) => ({
        ...(isUpdate && {
            id: lotId.current
        }),

        brandId,

        expoId: values.expoId,
        expoName: values.expoName,
        memberId: values.memberId,
        lotName: values.lotName,
        serviceName: values.serviceName,

        rate: values.rate,
        weight: values.weight,
        price: values.price,

        saleAmount: values.saleAmount,
        markerName: values.markerName,

        percentage: values.percentage,
        serviceFee: values.serviceFee,
        totalPrice: values.totalPrice,

        description: values.description ?? "",

        carryFeeList: values.carryFeeList?.map(x => ({
            brandId: x.brandId,
            productId: x.productId,
            markerName: x.markerName,
            date: x.date,
            carryName: x.carryName,
            count: x.count,
            rate: x.rate,
            weight: x.weight,
            totalPrice: x.totalPrice,
            description: x.description ?? ""
        })) ?? [],

        protectionPriceList:
            values.protectionPriceList?.map(x => ({
                brandId: x.brandId,
                lotName: x.lotName,
                serviceName: x.serviceName,
                rate: x.rate,
                weight: x.weight,
                price: x.price,
                percent: x.percent,
                amount: x.amount,
                description: x.description ?? ""
            })) ?? [],

        refundPriceList:
            values.refundPriceList?.map(x => ({
                brandId: x.brandId,
                price: x.price,
                percent: x.percent,
                amount: x.amount,
                description: x.description ?? ""
            })) ?? [],

        colorEnhancedFeeList:
            values.colorEnhancedFeeList ?? [],

        depositList:
            values.depositList ?? []
    });

    const submitLotHandler = async (values, actions) => {

        const isUpdate = isEdit;

        const payload = buildLotPayload(
            values,
            isUpdate
        );

        const apiUrl = isUpdate
            ? "Admin/UpdateLot"
            : "Admin/CreateLot";

        try {

            const result = await api.post(
                apiUrl,
                payload,
                getToken()
            );

            apiUtil.parseResult(result, response => {

                if (response.data.code === 200) {

                    message.success(
                        isUpdate
                            ? "Lot updated successfully!"
                            : "Lot saved successfully!"
                    );


                    actions.resetForm();

                    setIsEdit(false);
                    setShowAddLot(false);

                    retrieveLotList();

                }

            });


        } catch (error) {

            console.log(error);

        }

    };

    const brandId = authStore((state) => state.auth?.brandId);
    const clickAddLot = () => {
        if (isEdit) {
            setIsEdit(false);
            setTimeout(() => setShowAddLot(true), 100);
        } else {
            setShowAddLot(true);
        }
        setIsView(false);
        getAllExpoName();
        getAllMemberMakerName();
        setDetailLot({});
        setProductListByMember([]);
    };

    const clickEditLot = (e, id) => {
        setIsView(false);
        e.stopPropagation();
        clickBtnCloseForm();
        getAllExpoName();
        getAllMemberMakerName();
        getLotDetail(id, "edit");
    };

    const clickViewLot = (e, id) => {
        e.stopPropagation();
        clickBtnCloseForm();
        getLotDetail(id, "view");
    };

    const getAllExpoName = async () => {
        const data = await apiUtil.loadLookup(
            api,
            getToken,
            "Admin/GetExpoList",
            {
                rowLimit: 1000,
                currentPage: 1,
                brandId
            }
        );

        setExpoNameList(data);
    };

    const getAllMemberMakerName = async () => {
        const data = await apiUtil.loadLookup(
            api,
            getToken,
            "Admin/GetMemberListByAdmin",
            {
                rowLimit: 1000,
                currentPage: 1,
                brandId
            }
        );

        setMarkerNameList(data);
    };

    const getProductListByMemberId = async (memberId) => {
        if (!memberId) {
            setProductListByMember([]);
            return;
        }

        try {
            const result = await api.post(
                "Admin/GetProductListByMemberId",
                {
                    memberId,
                    currentPage: 1,
                    rowLimit: 1000,
                },
                getToken()
            );

            apiUtil.parseResult(
                result,
                (response) => {
                    if (response.data.code === 401) {
                        message.warning(response.data.message);
                        redirectToLogin();
                        return;
                    }
                    if (response.data.code === 200) {
                        setProductListByMember(response.data.data?.data ?? []);
                        return;
                    }
                    setProductListByMember([]);
                },
                (error) => {
                    console.log(error);
                    message.error("Failed to load product list.");
                    setProductListByMember([]);
                }
            );
        } catch (error) {
            console.log(error);
            message.error("Failed to load product list.");
            setProductListByMember([]);
        }
    };

    useEffect(() => {
        if (!isEdit) return;
        if (productListByMember.length === 0) return;
        if (!detailLot?.carryFeeList || detailLot.carryFeeList.length === 0) return;

        const needsBackfill = detailLot.carryFeeList.some(item => !item.productId);
        if (!needsBackfill) return;

        const updatedCarryFeeList = detailLot.carryFeeList.map(item => {
            if (item.productId) return item;

            const matched = productListByMember.find(
                p => p.date && format(parseISO(p.date), 'yyyy-MM-dd') === item.date
            );

            return matched ? { ...item, productId: matched.id } : item;
        });

        setDetailLot(prev => ({
            ...prev,
            carryFeeList: updatedCarryFeeList,
        }));
    }, [productListByMember, isEdit]);

    const expoNameSelectList = useMemo(() => {
        return expoNameList.map(x => ({
            label: `${x.expoName} (${format(parseISO(x.date), "dd-MM-yyyy")})`,
            value: x.id
        }));
    }, [expoNameList]);

    const markerNameSelectList = useMemo(() => {
        return markerNameList.map(x => ({
            label: x.markerName,
            value: x.id,
        }));
    }, [markerNameList]);

    const productDateSelectList = useMemo(() => {
        return productListByMember.map(x => ({
            label: format(parseISO(x.date), "dd-MM-yyyy"),
            value: x.id,
        }));
    }, [productListByMember]);

    const clickBtnCloseForm = () => {
        setShowAddLot(false);
        setIsEdit(false);
        setIsView(false);
    };

    const [lotList, setLotList] = useState({
        isLoading: false,
        grouping: false,
        limit: apiUtil.getDefaultPageSize(),
        data: [],
        total: 0,
        page: 1,
    });

    const [paramLot, setParamLot] = useState({
        keyword: "",
        rowLimit: 10,
        currentPage: 1,
        sortBy: "",
        isDesc: true,
        brandId: brandId,
    });

    const retrieveLotList = async (value = paramLot) => {
        const request = {
            ...value,
            keyword: value.keyword || "",
            sortBy: selectedOption ? selectedOption.value : "",
        };

        try {
            setLotList(prev => ({
                ...prev,
                isLoading: true,
            }));

            const result = await api.post(
                "Admin/GetLotList",
                request,
                getToken()
            );

            apiUtil.parseResult(
                result,
                (response) => {
                    const { code, data } = response.data;
                    if (code === 401) {
                        message.warning(response.data.message);
                        redirectToLogin();

                        return;
                    }
                    if (code === 200) {
                        setLotList({
                            isLoading: false,
                            limit: data.rowLimit,
                            data:
                                data.data && data.data.length > 0
                                    ? data.data
                                    : [],
                            total: data.totalRecords,
                            page: data.paging,
                        });
                        setTimeout(() => {
                            window.scrollTo({ top: 0, behavior: "smooth" });
                        }, 0);
                        return;
                    }
                    setLotList(prev => ({
                        ...prev,
                        isLoading: false,
                        data: [],
                        total: 0,
                        page: 0,
                        limit: 0,
                    }));
                },
                (error) => {

                    console.error(error);
                    message.error("Failed to load lot list.");

                    setLotList(prev => ({
                        ...prev,
                        isLoading: false,
                        data: [],
                        total: 0,
                        page: 0,
                        limit: 0
                    }));

                }
            );
        } catch (error) {

            console.error(error);
            message.error("Failed to load lot list.");

            setLotList(prev => ({
                ...prev,
                isLoading: false
            }));
        }
    };

    const getLotDetail = (id, mode = "edit") => {
        api
            .get("Admin/GetLotById", { lotId: id }, getToken())
            .then((result) => {
                apiUtil.parseResult(
                    result,
                    (response) => {
                        if (response.data.code === 401) {
                            message.warning(response.data.message);
                            redirectToLogin();
                        } else if (response.data.code === 200) {
                            setDetailLot(
                                mapLot(response.data.data)
                            );
                            lotId.current = id;
                            setIsEdit(mode === "edit");
                            setIsView(mode === "view");
                            setShowAddLot(false);


                            if (mode === "edit" && response.data.data?.memberId) {
                                getProductListByMemberId(response.data.data.memberId);
                            }

                            setTimeout(() => {
                                window.scrollTo({ top: 0, behavior: "smooth" });
                            }, 0);
                        } else {
                            message.error(response.data.message);
                        }
                    },
                    (error, type) => {
                        console.log(error);
                    }
                );
            });
    };

    // Add Lot Validation Form
    const AddLotValidation = Yup.object().shape({
        expoId: Yup.string().required("Please select the expo"),
        lotName: Yup.string().required("Please enter the lot name."),
        serviceName: Yup.string().required("Please enter the  name."),
        rate: Yup.string().required("Please enter the quantity."),
        weight: Yup.string().required("Please enter the weight."),
        price: Yup.string().required("Please enter the price."),
        saleAmount: Yup.string().required("Please enter the sale amount."),
        memberId: Yup.string().required("Please enter the customer name."),
        percentage: Yup.string().required("Please enter the percentage."),
        carryFeeList: Yup.array().of(
            Yup.object().shape({
                date: Yup.date().required("Please select the date."),
                rate: Yup.string().required("Please enter the quantity."),
                weight: Yup.string().required("Please enter the weight."),
                totalPrice: Yup.string().required("Please enter the price."),
            })
        ),
        protectionPriceList: Yup.array().of(
            Yup.object().shape({
                lotName: Yup.string().required("Please enter the log name."),
                serviceName: Yup.string().required("Please enter the service name."),
                rate: Yup.number()
                    .typeError("Rate must be a number.")
                    .positive("Rate must be greater than zero.")
                    .required("Please enter the quantity."),
                weight: Yup.number()
                    .typeError("Weight must be a number.")
                    .positive("Weight must be greater than zero.")
                    .required("Please enter the weight."),
                price: Yup.number()
                    .typeError("Price must be a number.")
                    .positive("Price must be greater than zero.")
                    .required("Please enter the price."),
                percent: Yup.number().required("Please enter the percent."),
                amount: Yup.number().required("Please enter the amount")
            })
        ),
        refundPriceList: Yup.array().of(
            Yup.object().shape({
                price: Yup.number()
                    .typeError("Price must be a number.")
                    .positive("Price must be greater than zero.")
                    .required("Please enter the price."),
                percent: Yup.number().required("Please enter the percent."),
                amount: Yup.number().required("Please enter the amount")
            })
        ),
        colorEnhancedFeeList: Yup.array().of(
            Yup.object().shape({
                price: Yup.number()
                    .typeError("Price must be a number.")
                    .positive("Price must be greater than zero.")
                    .required("Please enter the price."),
                description: Yup.string().required("Please enter the note."),
            }),
        ),
        depositList: Yup.array().of(
            Yup.object().shape({
                price: Yup.number()
                    .typeError("Price must be a number.")
                    .positive("Price must be greater than zero.")
                    .required("Please enter the price."),
                description: Yup.string().required("Please enter the note."),
            })
        )
    });

    useEffect(() => {
        retrieveLotList({
            ...paramLot,
            keyword
        });
    }, [paramLot.currentPage, selectedOption]);

    let pageTitle;
    if (showAddLot) {
        pageTitle = "Add Lot";
    } else if (isEdit) {
        pageTitle = "Edit Lot";
    } else {
        pageTitle = "Lot Detail";
    }

    return (
        <>
            {(showAddLot || isEdit || isView) && (
                <>
                    <div className="Actions space_between">
                        <h6 className="title_text mt-2">{pageTitle}</h6>
                        <button className="btn btnClose" onClick={clickBtnCloseForm}>
                            <img src={close} className="imgClose" alt="imgClose" />
                        </button>
                    </div>

                    {showAddLot || isEdit ? (
                        <Formik
                            enableReinitialize={true}
                            initialValues={mapLot(detailLot)}
                            validationSchema={AddLotValidation}
                            validateOnBlur={false}
                            onSubmit={submitLotHandler}
                        >
                            {({ errors, touched, values, setFieldValue }) => (
                                <Form className="row form-container add-lot-form">
                                    <div className="col-6 mt-2">
                                        <CustomSelect
                                            options={expoNameSelectList}
                                            name="expoId"
                                            label="Expo"
                                            isclearable={false}
                                            placeholder="Select Expo"
                                            refSelect={refSelectExpo}
                                            onChange={(selectedOption) => {
                                                setFieldValue("expoName", selectedOption ? selectedOption.label : "");
                                                setFieldValue("expoId", selectedOption ? selectedOption.value : "");
                                            }}
                                        />
                                    </div>
                                    <div className="col-6 mt-2">
                                        <CustomInput
                                            name="lotName"
                                            type="text"
                                            label="Lot Name"
                                            placeholder="Lot Name"
                                            value={values.lotName}
                                            customclass="input_wrapper"
                                            hideicon="true"
                                        />
                                    </div>

                                    <div className="col-6 mt-2">
                                        <CustomInput
                                            name="serviceName"
                                            type="text"
                                            label="Service Name"
                                            customclass="input_wrapper"
                                            hideicon="true"
                                            isclearable={true}
                                            value={values.serviceName}
                                            placeholder="Service Name"
                                        />
                                    </div>

                                    <div className="col-6 mt-2">
                                        <CustomSelect
                                            options={markerNameSelectList}
                                            name="memberId"
                                            label="Customer Name"
                                            isclearable={false}
                                            placeholder="Select Marker"
                                            refSelect={refSelectMarker}
                                            onChange={(selectedOption) => {
                                                const newMemberId = selectedOption ? selectedOption.value : "";

                                                setFieldValue("markerName", selectedOption ? selectedOption.label : "");
                                                setFieldValue("memberId", newMemberId);

                                                setProductListByMember([]);
                                                setFieldValue("carryFeeList", []);
                                            }}
                                        />
                                    </div>

                                    <div className="col-2 mt-2">
                                        <CustomInput
                                            name="rate"
                                            type="number"
                                            step="0.1"
                                            label="Quantity"
                                            placeholder="Quantity"
                                            customclass="input_wrapper"
                                            hideicon="true"
                                        />
                                    </div>

                                    <div className="col-2 mt-2">
                                        <CustomInput
                                            name="weight"
                                            type="number"
                                            step="0.1"
                                            label="Weight (kg)"
                                            customclass="input_wrapper"
                                            placeholder="Weight"
                                            hideicon="true"
                                        />
                                    </div>

                                    <div className="col-4 mt-2">
                                        <CustomInput
                                            name="price"
                                            type="text"
                                            label="Price"
                                            placeholder="Enter Price"
                                            customclass="input_wrapper"
                                            hideicon="true"
                                        />
                                    </div>

                                    <div className="col-4 mt-2">
                                        <CustomInput
                                            name="saleAmount"
                                            type="number"
                                            label="Sale Amount"
                                            placeholder="Sale Amount"
                                            customclass="input_wrapper"
                                            value={values.saleAmount}
                                            hideicon="true"
                                            onChange={(value) => {
                                                const numericSale = parseFloat(value) || 0;
                                                const numericPercent = parseFloat(values.percentage) || 0;
                                                const calculatedServiceFee = numericSale * (numericPercent / 100);
                                                const calculatedTotalPrice = numericSale - calculatedServiceFee;

                                                setFieldValue("saleAmount", value);
                                                setFieldValue("serviceFee", Math.round(calculatedServiceFee.toFixed(2)));
                                                setFieldValue("totalPrice", Math.round(calculatedTotalPrice.toFixed(2)));
                                            }}
                                        />
                                    </div>

                                    <div className="col-2 mt-2">
                                        <CustomInput
                                            name="percentage"
                                            type="number"
                                            step="0.1"
                                            label="Percent"
                                            placeholder="Percent"
                                            customclass="input_wrapper"
                                            hideicon="true"
                                            value={values.percentage}
                                            onChange={(value) => {
                                                const numericSale = parseFloat(values.saleAmount) || 0;
                                                const numericPercent = parseFloat(value) || 0;
                                                const calculatedServiceFee = numericSale * (numericPercent / 100);
                                                const calculatedTotalPrice = numericSale - calculatedServiceFee;

                                                setFieldValue("percentage", value);
                                                setFieldValue("serviceFee", Math.round(calculatedServiceFee.toFixed(2)));
                                                setFieldValue("totalPrice", Math.round(calculatedTotalPrice.toFixed(2)));
                                            }}
                                        />
                                    </div>

                                    <div className="col-2 mt-2">
                                        <CustomInput
                                            name="serviceFee"
                                            type="number"
                                            label="Service Fee"
                                            placeholder="Service Fee"
                                            customclass="input_wrapper"
                                            hideicon="true"
                                            value={values.serviceFee}
                                            readOnly
                                        />
                                    </div>

                                    <div className="col-4 mt-2">
                                        <CustomInput
                                            name="totalPrice"
                                            type="number"
                                            label="Total Price"
                                            placeholder="Total Price"
                                            customclass="input_wrapper"
                                            hideicon="true"
                                            value={values.totalPrice}
                                            readOnly
                                        />
                                    </div>

                                    <div className="col-4 mt-2">
                                        <CustomInput
                                            name="description"
                                            type="text"
                                            label="Note"
                                            placeholder="Note"
                                            customclass="input_wrapper"
                                            hideicon="true"
                                            value={values.description}
                                        />
                                    </div>

                                    <div className="col-12 mt-2">
                                        <FieldArray
                                            name="carryFeeList"
                                            render={(arrayHelpers) => (
                                                <div>
                                                    {values.carryFeeList.map((detail, index) => (
                                                        <div key={index} className="row">
                                                            <div className="col-3 mt-2">
                                                                <CustomSelect
                                                                    options={productDateSelectList}
                                                                    name={`carryFeeList[${index}].productId`}
                                                                    label="Date"
                                                                    isclearable={false}
                                                                    placeholder="Select Date"
                                                                    onChange={(selectedOption) => {
                                                                        const selectedProduct = productListByMember.find(
                                                                            p => p.id === selectedOption?.value
                                                                        );

                                                                        setFieldValue(
                                                                            `carryFeeList[${index}].productId`,
                                                                            selectedOption ? selectedOption.value : ""
                                                                        );
                                                                        setFieldValue(
                                                                            `carryFeeList[${index}].date`,
                                                                            selectedProduct?.date
                                                                                ? format(parseISO(selectedProduct.date), 'yyyy-MM-dd')
                                                                                : ""
                                                                        );
                                                                           setFieldValue(
                                                                            `carryFeeList[${index}].carryName`,
                                                                            selectedProduct?.carryName ?? ""
                                                                        );
                                                                        setFieldValue(
                                                                            `carryFeeList[${index}].count`,
                                                                            selectedProduct?.count ?? ""
                                                                        );
                                                                        setFieldValue(
                                                                            `carryFeeList[${index}].rate`,
                                                                            selectedProduct?.rate ?? ""
                                                                        );
                                                                        setFieldValue(
                                                                            `carryFeeList[${index}].weight`,
                                                                            selectedProduct?.weight ?? ""
                                                                        );
                                                                        setFieldValue(
                                                                            `carryFeeList[${index}].totalPrice`,
                                                                            selectedProduct?.price ?? ""
                                                                        );
                                                                        setFieldValue(
                                                                            `carryFeeList[${index}].description`,
                                                                            selectedProduct?.description ?? ""
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                             <div className="col-3 mt-2">
                                                                <CustomInput
                                                                    name={`carryFeeList[${index}].carryName`}
                                                                    type="text"
                                                                    label="Carry Name"
                                                                    placeholder="Carry Name"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                    value={detail.carryName}
                                                                    readOnly
                                                                />
                                                            </div>
                                                             <div className="col-3 mt-2">
                                                                <CustomInput
                                                                    name={`carryFeeList[${index}].count`}
                                                                    type="number"
                                                                    step="0.1"
                                                                    label="Quantity"
                                                                    placeholder="Count"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                    value={detail.count}
                                                                    readOnly
                                                                />
                                                            </div>
                                                            <div className="col-3 mt-2">
                                                                <CustomInput
                                                                    name={`carryFeeList[${index}].rate`}
                                                                    type="number"
                                                                    step="0.1"
                                                                    label="Rate"
                                                                    placeholder="Rate"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                    value={detail.rate}
                                                                    readOnly
                                                                />
                                                            </div>
                                                            <div className="col-3 mt-2">
                                                                <CustomInput
                                                                    name={`carryFeeList[${index}].weight`}
                                                                    type="number"
                                                                    step="0.1"
                                                                    label="Weight"
                                                                    placeholder="Weight"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                    value={detail.weight}
                                                                    readOnly
                                                                />
                                                            </div>
                                                            <div className="col-3 mt-2">
                                                                <CustomInput
                                                                    name={`carryFeeList[${index}].totalPrice`}
                                                                    type="number"
                                                                    label="Price"
                                                                    placeholder="Price"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                    value={detail.totalPrice}
                                                                    readOnly
                                                                />
                                                            </div>
                                                            <div className="col-3 mt-2">
                                                                <CustomInput
                                                                    name={`carryFeeList[${index}].description`}
                                                                    type="text"
                                                                    label="Note"
                                                                    placeholder="Note"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                    value={detail.description}
                                                                    readOnly
                                                                />
                                                            </div>
                                                            <div className="col-3 d-flex align-items-center">
                                                                <button
                                                                    type="button"
                                                                    className="button btnRemove"
                                                                    onClick={() => arrayHelpers.remove(index)}
                                                                >
                                                                    Remove
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    <button
                                                        type="button"
                                                        className="button btnAddDetail mt-3"
                                                        onClick={async () => {
                                                            if (!values.memberId) {
                                                                message.warning("Please select customer name first.");
                                                                return;
                                                            }

                                                            await getProductListByMemberId(values.memberId);

                                                            arrayHelpers.push({
                                                                markerName: values.markerName,
                                                                productId: "",
                                                                date: "",
                                                                carryName: "",
                                                                count: "",
                                                                rate: "",
                                                                weight: "",
                                                                totalPrice: "",
                                                                description: "",
                                                            });
                                                        }}
                                                    >
                                                        ကယ်ရီခ ထည့်ရန် နှိပ်ပါ
                                                    </button>
                                                </div>
                                            )}
                                        />
                                    </div>

                                    <div className="col-12 mt-2">
                                        <FieldArray
                                            name="protectionPriceList"
                                            render={(arrayHelpers) => (
                                                <>
                                                    {values.protectionPriceList.map((detail, index) => (
                                                        <div key={index} className="row align-items-center">
                                                            <div className="col-2 mt-2">
                                                                <CustomInput
                                                                    name={`protectionPriceList[${index}].lotName`}
                                                                    type="text"
                                                                    label="Lot Name"
                                                                    placeholder="Lot Name"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                />
                                                            </div>
                                                            <div className="col-2 mt-2">
                                                                <CustomInput
                                                                    name={`protectionPriceList[${index}].serviceName`}
                                                                    type="text"
                                                                    label="Service Name"
                                                                    placeholder="Service Name"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                />
                                                            </div>
                                                            <div className="col-2 mt-2">
                                                                <CustomInput
                                                                    name={`protectionPriceList[${index}].rate`}
                                                                    type="number"
                                                                    step="0.1"
                                                                    label="Quantity"
                                                                    placeholder="Quantity"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                    value={detail.rate}
                                                                />
                                                            </div>
                                                            <div className="col-2 mt-2">
                                                                <CustomInput
                                                                    name={`protectionPriceList[${index}].weight`}
                                                                    type="number"
                                                                    step="0.1"
                                                                    label="Weight"
                                                                    placeholder="Weight"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                    value={detail.weight}
                                                                />
                                                            </div>
                                                            <div className="col-4 mt-2">
                                                                <CustomInput
                                                                    name={`protectionPriceList[${index}].price`}
                                                                    type="number"
                                                                    label="Price"
                                                                    placeholder="Price"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                    value={detail.price}
                                                                    onChange={(value) => {
                                                                        const numericPrice = parseFloat(value) || 0;
                                                                        const numericPercent = parseFloat(detail.percent) || 0;
                                                                        const calculatedProetctedFee = numericPrice * (numericPercent / 100);

                                                                        setFieldValue(`protectionPriceList[${index}].price`, value);
                                                                        setFieldValue(`protectionPriceList[${index}].amount`, calculatedProetctedFee.toFixed(2));
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="col-3 mt-2">
                                                                <CustomInput
                                                                    name={`protectionPriceList[${index}].percent`}
                                                                    type="number"
                                                                    label="Percent"
                                                                    placeholder="Percent"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                    value={detail.percent}
                                                                    onChange={(value) => {
                                                                        const numericPrice = parseFloat(detail.price) || 0;
                                                                        const numericPercent = parseFloat(value) || 0;
                                                                        const calculatedProtectedFee = numericPrice * (numericPercent / 100);

                                                                        setFieldValue(`protectionPriceList[${index}].percent`, value);
                                                                        setFieldValue(`protectionPriceList[${index}].amount`, calculatedProtectedFee.toFixed(2));
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="col-3 mt-2">
                                                                <CustomInput
                                                                    name={`protectionPriceList[${index}].amount`}
                                                                    type="number"
                                                                    label="Amount"
                                                                    placeholder="Amount"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                    value={detail.amount}
                                                                    readOnly
                                                                />
                                                            </div>

                                                            <div className="col-4 mt-2">
                                                                <CustomInput
                                                                    name={`protectionPriceList[${index}].description`}
                                                                    type="text"
                                                                    label="Note"
                                                                    placeholder="Note"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                />
                                                            </div>
                                                            <div className="col-2 ">
                                                                <button
                                                                    type="button"
                                                                    className="button btnRemove"
                                                                    onClick={() => arrayHelpers.remove(index)}
                                                                >
                                                                    Remove
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    <button
                                                        type="button"
                                                        className="button btnAddDetail mt-3"
                                                        onClick={() =>
                                                            arrayHelpers.push({
                                                                lotName: "",
                                                                serviceName: "",
                                                                rate: "",
                                                                weight: "",
                                                                description: "",
                                                                price: "",
                                                                percent: "",
                                                                amount: "",
                                                            })
                                                        }
                                                    >
                                                        ကာစျေး ထည့်ရန် နှိပ်ပါ
                                                    </button>
                                                </>
                                            )}
                                        />
                                    </div>

                                    <div className="col-12 mt-2">
                                        <FieldArray
                                            name="refundPriceList"
                                            render={(arrayHelpers) => (
                                                <>
                                                    {values.refundPriceList.map((detail, index) => (
                                                        <div key={index} className="row align-items-center">
                                                            <div className="col-2 mt-2">
                                                                <CustomInput
                                                                    name={`refundPriceList[${index}].price`}
                                                                    type="number"
                                                                    label="Price"
                                                                    placeholder="Price"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                    value={detail.price}
                                                                    onChange={value => {
                                                                        const numericPrice = parseFloat(value) || 0;
                                                                        const numericPercent = parseFloat(detail.percent) || 0;
                                                                        const calculatedRefundFee = numericPrice * (numericPercent / 100);

                                                                        setFieldValue(`refundPriceList[${index}].price`, value);
                                                                        setFieldValue(`refundPriceList[${index}].amount`, calculatedRefundFee.toFixed(2));
                                                                    }}
                                                                />
                                                            </div>

                                                            <div className="col-2 mt-2">
                                                                <CustomInput
                                                                    name={`refundPriceList[${index}].percent`}
                                                                    type="number"
                                                                    label="Percent"
                                                                    placeholder="Percent"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                    value={detail.percent}
                                                                    onChange={value => {
                                                                        const numericPercent = parseFloat(value) || 0;
                                                                        const numericPrice = parseFloat(detail.price) || 0;
                                                                        const calculatedRefundFee = numericPrice * (numericPercent / 100);

                                                                        setFieldValue(`refundPriceList[${index}].percent`, value);
                                                                        setFieldValue(`refundPriceList[${index}].amount`, calculatedRefundFee.toFixed(2));
                                                                    }}
                                                                />
                                                            </div>

                                                            <div className="col-2 mt-2">
                                                                <CustomInput
                                                                    name={`refundPriceList[${index}].amount`}
                                                                    type="number"
                                                                    step="0.1"
                                                                    label="Amount"
                                                                    placeholder="Amount"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                    value={detail.amount}
                                                                    readOnly
                                                                />
                                                            </div>

                                                            <div className="col-4 mt-2">
                                                                <CustomInput
                                                                    name={`refundPriceList[${index}].description`}
                                                                    type="text"
                                                                    label="Note"
                                                                    placeholder="Note"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                    value={detail.description}
                                                                />
                                                            </div>
                                                            <div className="col-2 ">
                                                                <button
                                                                    type="button"
                                                                    className="button btnRemove"
                                                                    onClick={() => arrayHelpers.remove(index)}
                                                                >
                                                                    Remove
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    <button
                                                        type="button"
                                                        className="button btnAddDetail mt-3"
                                                        onClick={() =>
                                                            arrayHelpers.push({
                                                                price: "",
                                                                percent: "",
                                                                amount: "",
                                                                description: "",
                                                            })
                                                        }
                                                    >
                                                        လျော်ကြေး ထည့်ရန် နှိပ်ပါ
                                                    </button>
                                                </>
                                            )}
                                        />
                                    </div>

                                    <div className="col-12 mt-2">
                                        <FieldArray
                                            name="colorEnhancedFeeList"
                                            render={(arrayHelpers) => (
                                                <>
                                                    {values.colorEnhancedFeeList.map((detail, index) => (
                                                        <div key={index} className="row align-items-center">
                                                            <div className="col-4 mt-2">
                                                                <CustomInput
                                                                    name={`colorEnhancedFeeList[${index}].price`}
                                                                    type="number"
                                                                    label="Price"
                                                                    placeholder="Price"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                    value={detail.price}
                                                                />
                                                            </div>

                                                            <div className="col-6 mt-2">
                                                                <CustomInput
                                                                    name={`colorEnhancedFeeList[${index}].description`}
                                                                    type="text"
                                                                    label="Note"
                                                                    placeholder="Note"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                    value={detail.description}
                                                                />
                                                            </div>
                                                            <div className="col-2 ">
                                                                <button
                                                                    type="button"
                                                                    className="button btnRemove"
                                                                    onClick={() => arrayHelpers.remove(index)}
                                                                >
                                                                    Remove
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    <button
                                                        type="button"
                                                        className="button btnAddDetail mt-3"
                                                        onClick={() =>
                                                            arrayHelpers.push({
                                                                price: "",
                                                                description: "",
                                                            })
                                                        }
                                                    >
                                                        အရောင်တင်ခ ထည့်ရန် နှိပ်ပါ
                                                    </button>
                                                </>
                                            )}
                                        />
                                    </div>

                                    <div className="col-12 mt-2">
                                        <FieldArray
                                            name="depositList"
                                            render={(arrayHelpers) => (
                                                <>
                                                    {values.depositList.map((detail, index) => (
                                                        <div key={index} className="row align-items-center">
                                                            <div className="col-4 mt-2">
                                                                <CustomInput
                                                                    name={`depositList[${index}].price`}
                                                                    type="number"
                                                                    label="Price"
                                                                    placeholder="Price"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                    value={detail.price}
                                                                />
                                                            </div>

                                                            <div className="col-6 mt-2">
                                                                <CustomInput
                                                                    name={`depositList[${index}].description`}
                                                                    type="text"
                                                                    label="Note"
                                                                    placeholder="Note"
                                                                    customclass="input_wrapper"
                                                                    hideicon="true"
                                                                    value={detail.description}
                                                                />
                                                            </div>
                                                            <div className="col-2 ">
                                                                <button
                                                                    type="button"
                                                                    className="button btnRemove"
                                                                    onClick={() => arrayHelpers.remove(index)}
                                                                >
                                                                    Remove
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ))}
                                                    <button
                                                        type="button"
                                                        className="button btnAddDetail mt-3"
                                                        onClick={() =>
                                                            arrayHelpers.push({
                                                                price: "",
                                                                description: "",
                                                            })
                                                        }
                                                    >
                                                        အပ်ငွေ ထည့်ရန် နှိပ်ပါ
                                                    </button>
                                                </>
                                            )}
                                        />
                                    </div>

                                    <div className="col-12 mt-3">
                                        <div className="Actions justify-content-end">
                                            <button
                                                type="button"
                                                className="button btnCancel"
                                                onClick={clickBtnCloseForm}
                                            >
                                                Cancel
                                            </button>
                                            <button type="submit" className="button btnAddPM">
                                                {showAddLot ? "Create" : "Update"}
                                            </button>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    ) : null}

                    {isView && (
                        <>
                            <Formik
                                initialValues={detailLot}
                                validateOnBlur={false}
                            >
                                {({ errors, touched, setFieldValue }) => (
                                    <Form className="row form-container add-lot-form">
                                        <div className="col-6 mt-2">
                                            <CustomInput
                                                name="expoName"
                                                label="Expo"
                                                isclearable={false}
                                                readOnly={true}
                                                hideicon="true"
                                            />
                                        </div>
                                        <div className="col-6 mt-2">
                                            <CustomInput
                                                name="lotName"
                                                type="text"
                                                label="Lot Name"
                                                customclass="input_wrapper"
                                                hideicon="true"
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-6 mt-2">
                                            <CustomInput
                                                name="serviceName"
                                                type="text"
                                                label="Service Name"
                                                customclass="input_wrapper"
                                                hideicon="true"
                                                isclearable={true}
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-6 mt-2">
                                            <CustomInput
                                                name="markerName"
                                                label="Customer Name"
                                                isclearable={false}
                                                hideicon="true"
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-2 mt-2">
                                            <CustomInput
                                                name="rate"
                                                type="number"
                                                step="0.1"
                                                label="Quantity"
                                                customclass="input_wrapper"
                                                hideicon="true"
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-2 mt-2">
                                            <CustomInput
                                                name="weight"
                                                type="number"
                                                step="0.1"
                                                label="Weight (kg)"
                                                customclass="input_wrapper"
                                                placeholder="Weight"
                                                hideicon="true"
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-4 mt-2">
                                            <CustomInput
                                                name="price"
                                                type="text"
                                                label="Price"
                                                customclass="input_wrapper"
                                                hideicon="true"
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-4 mt-2">
                                            <CustomInput
                                                name="saleAmount"
                                                type="number"
                                                label="Sale Amount"
                                                customclass="input_wrapper"
                                                hideicon="true"
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-2 mt-2">
                                            <CustomInput
                                                name="percentage"
                                                type="number"
                                                label="Percent"
                                                customclass="input_wrapper"
                                                hideicon="true"
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-2 mt-2">
                                            <CustomInput
                                                name="serviceFee"
                                                type="number"
                                                label="Service Fee"
                                                customclass="input_wrapper"
                                                hideicon="true"
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-4 mt-2">
                                            <CustomInput
                                                name="totalPrice"
                                                type="number"
                                                label="Total Price"
                                                customclass="input_wrapper"
                                                hideicon="true"
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-4 mt-2">
                                            <CustomInput
                                                name="description"
                                                type="text"
                                                label="Note"
                                                customclass="input_wrapper"
                                                hideicon="true"
                                                readOnly
                                            />
                                        </div>

                                        {detailLot.carryFeeList?.map((detail, index) => (
                                            <>
                                                <h4 className="title_text mt-2">Carry Fee</h4>
                                                <div className="col-3 mt-2">
                                                    <CustomInput
                                                        name={`carryFeeList[${index}].date`}
                                                        type="date"
                                                        label="Date"
                                                        value={new Date(detail.date).toLocaleDateString("eng-US")}
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>
                                                <div className="col-3 mt-2">
                                                    <CustomInput
                                                        name={`carryFeeList[${index}].carryName`}
                                                        type="text"
                                                        label="Carry Name"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>
                                                <div className="col-3 mt-2">
                                                    <CustomInput
                                                        name={`carryFeeList[${index}].count`}
                                                        type="number"
                                                        label="Count"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>
                                                <div className="col-3 mt-2">
                                                    <CustomInput
                                                        name={`carryFeeList[${index}].rate`}
                                                        type="number"
                                                        step="0.1"
                                                        label="Rate"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>
                                                <div className="col-3 mt-2">
                                                    <CustomInput
                                                        name={`carryFeeList[${index}].weight`}
                                                        type="number"
                                                        step="0.1"
                                                        label="Weight"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>
                                                <div className="col-3 mt-2">
                                                    <CustomInput
                                                        name={`carryFeeList[${index}].totalPrice`}
                                                        type="number"
                                                        label="Price"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>
                                                <div className="col-6 mt-2">
                                                    <CustomInput
                                                        name={`carryFeeList[${index}].description`}
                                                        type="text"
                                                        label="Note"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>
                                            </>
                                        ))}

                                        {detailLot.protectionPriceList?.map((detail, index) => (
                                            <>
                                                <h4 className="title_text mt-2">Protection Price</h4>
                                                <div className="col-2 mt-2">
                                                    <CustomInput
                                                        name={`protectionPriceList[${index}].lotName`}
                                                        type="text"
                                                        label="Lot Name"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>
                                                <div className="col-2 mt-2">
                                                    <CustomInput
                                                        name={`protectionPriceList[${index}].serviceName`}
                                                        type="text"
                                                        label="Service Name"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>
                                                <div className="col-2 mt-2">
                                                    <CustomInput
                                                        name={`protectionPriceList[${index}].rate`}
                                                        type="number"
                                                        step="0.1"
                                                        label="Quantity"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>
                                                <div className="col-2 mt-2">
                                                    <CustomInput
                                                        name={`protectionPriceList[${index}].weight`}
                                                        type="number"
                                                        step="0.1"
                                                        label="Weight"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>
                                                <div className="col-4 mt-2">
                                                    <CustomInput
                                                        name={`protectionPriceList[${index}].price`}
                                                        type="number"
                                                        label="Price"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>
                                                <div className="col-4 mt-2">
                                                    <CustomInput
                                                        name={`protectionPriceList[${index}].percent`}
                                                        type="number"
                                                        label="Percent"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>
                                                <div className="col-4 mt-2">
                                                    <CustomInput
                                                        name={`protectionPriceList[${index}].amount`}
                                                        type="number"
                                                        label="Amount"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>

                                                <div className="col-4 mt-2">
                                                    <CustomInput
                                                        name={`protectionPriceList[${index}].description`}
                                                        type="text"
                                                        label="Note"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                    />
                                                </div>
                                            </>
                                        ))}

                                        {detailLot.refundPriceList?.map((detail, index) => (
                                            <>
                                                <h4 className="title_text mt-2">Refund Price</h4>
                                                <div className="col-2 mt-2">
                                                    <CustomInput
                                                        name={`refundPriceList[${index}].price`}
                                                        type="number"
                                                        label="Price"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>

                                                <div className="col-2 mt-2">
                                                    <CustomInput
                                                        name={`refundPriceList[${index}].percent`}
                                                        type="number"
                                                        label="Percent"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>

                                                <div className="col-4 mt-2">
                                                    <CustomInput
                                                        name={`refundPriceList[${index}].amount`}
                                                        type="number"
                                                        step="0.1"
                                                        label="Amount"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>

                                                <div className="col-4 mt-2">
                                                    <CustomInput
                                                        name={`refundPriceList[${index}].description`}
                                                        type="text"
                                                        label="Note"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>

                                            </>
                                        ))}

                                        {detailLot.colorEnhancedFeeList?.map((detail, index) => (
                                            <>
                                                <h4 className="title_text mt-2">Color Enhanced Fee</h4>
                                                <div className="col-6 mt-2">
                                                    <CustomInput
                                                        name={`colorEnhancedFeeList[${index}].price`}
                                                        type="number"
                                                        label="Price"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>

                                                <div className="col-6 mt-2">
                                                    <CustomInput
                                                        name={`colorEnhancedFeeList[${index}].description`}
                                                        type="text"
                                                        label="Note"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>
                                            </>
                                        ))}

                                        {detailLot.depositList?.map((detail, index) => (
                                            <>
                                                <h4 className="title_text mt-2">Deposit</h4>
                                                <div className="col-6 mt-2">
                                                    <CustomInput
                                                        name={`depositList[${index}].price`}
                                                        type="number"
                                                        label="Price"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>

                                                <div className="col-6 mt-2">
                                                    <CustomInput
                                                        name={`depositList[${index}].description`}
                                                        type="text"
                                                        label="Note"
                                                        customclass="input_wrapper"
                                                        hideicon="true"
                                                        readOnly
                                                    />
                                                </div>
                                            </>
                                        ))}
                                    </Form>
                                )}
                            </Formik>
                        </>
                    )}
                </>
            )
            }

            <div className="Actions space_between">
                <h6 className="title_text mt-2">Lot</h6>
                <div className="d-flex justify-content-end gap-16 align-items-center">
                    {/* <CustomFilter /> */}

                    <CustomSearchBar
                        value={keyword}
                        setValue={setKeyword}
                        onSearch={(value) => retrieveLotList({
                            ...paramLot,
                            keyword: value || "",
                            currentPage: 1
                        })}
                    />
                    {!showAddLot && (
                        <CustomButton
                            icon={add}
                            text="Add Lot"
                            addIcon={true}
                            className="btnAdd"
                            onClick={clickAddLot}
                        />
                    )}
                </div>
            </div>

            <div className="table_container lot_table">
                <Table
                    ref={refLotTable}
                    maxBodyHeight={lotList.limit * 100}
                    isLoading={lotList.isLoading}
                    grouping={lotList.grouping}
                    limit={lotList.limit}
                    page={lotList.page}
                    total={lotList.total}
                    data={lotList.data}
                    onPageChange={(page) => {
                        setParamLot({
                            ...paramLot,
                            currentPage: page,
                        });
                    }}
                    columns={[
                        {
                            title: "No",
                            render: (row) => row.tableIndex + 1
                        },
                        {
                            title: "Expo",
                            field: "expoName"
                        },
                        {
                            title: "Lot",
                            field: "lotName"
                        },
                        {
                            title: "Name",
                            field: "serviceName"
                        },
                        {
                            title: "Rate",
                            field: "rate",
                        },
                        {
                            title: "Weight (kg)",
                            field: "weight"
                        },
                        {
                            title: "Price",
                            field: "price",
                        },
                        {
                            title: "Sale",
                            render: (row) => {
                                return Number(row.saleAmount).toLocaleString();
                            }
                        },
                        {
                            title: "Customer",
                            field: "markerName"
                        },
                        {
                            title: "Percent",
                            field: "percentage"
                        },
                        {
                            title: "Total Price",
                            render: (row) => {
                                return Number(row.totalPrice).toLocaleString();
                            }
                        },
                        {
                            title: "Note",
                            field: "description"
                        },
                        {
                            title: "Edit",
                            sorting: false,
                            render: (row) => {
                                return (
                                    <Box
                                        className="editIcon"
                                        onClick={(e) => clickEditLot(e, row.id)}
                                    >
                                        <img src={edit} alt="" className="imgIcon" />
                                    </Box>
                                );
                            },
                            width: "80px",
                            align: "center",
                        },
                        {
                            title: "View",
                            sorting: false,
                            render: (row) => {
                                return (
                                    <Box
                                        className="viewIcon"
                                        onClick={(e) => clickViewLot(e, row.id)}
                                    >
                                        <img src={view} alt="" className="imgIcon" />
                                    </Box>
                                );
                            },
                            width: "80px",
                            align: "center",
                        },
                    ]}
                />
            </div>
        </>
    )
}
export default Lot;